import styled from 'styled-components';
import { Button } from 'grommet';
import { AppAnchor } from '@Components/Control';

const StyledModalButton = styled(Button)`
  -webkit-transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;

  &:hover {
    color: ${({ highlight }) => highlight};
  }
`;

const StyledMailtoAnchor = styled(AppAnchor)`
  -webkit-transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1) 0s;

  &:hover {
    color: ${({ highlight }) => highlight};
  }
`;

export {
  StyledModalButton,
  StyledMailtoAnchor,
};
